<template>
  <div
    class="
      t-bg-white t-border t-border-gray-100 t-shadow-md t-py-2 t-pb-4 t-px-5
      md:t-rounded-lg
    "
  >
    <!-- Card Heading -->
    <div class="t-flex t-justify-between t-items-center t-py-2">
      <div class="t-flex t-space-x-4 t-items-center">
        <p class="t-text-2xl t-font-bold hover:t-text-blue-900">
          <a :href="'/carry-freight/bookings/' + consignment.id">
            {{ consignment.number }}
          </a>
        </p>

        <div class="t-flex" style="position: relative">
          <div class="dropdown" style="margin: 0 0 0 10px">
            <button
              role="button"
              type="button"
              class="btn t-font-semibold t-py-2 t-px-3"
              style="color: #fff"
              :class="[
                {
                  'btn-error t-bg-crimson with-half-radius':
                    consignment.status_human === 'Booked' &&
                    (convertPickupAfter(consignment.pickup_after) >
                      currentDate ||
                      Boolean(consignment.ready_for_pickup) === false)
                },
                {
                  'btn-warning t-bg-orange with-half-radius':
                    consignment.status_human === 'Booked' &&
                    (convertPickupAfter(consignment.pickup_after) <=
                      currentDate ||
                      Boolean(consignment.ready_for_pickup) === true)
                },
                {
                  'btn-info t-bg-dodger-blue with-half-radius':
                    consignment.status_human === 'In Transit'
                },
                {
                  'btn-success t-bg-forest-green with-full-radius':
                    consignment.status_human === 'Delivered'
                },
                {
                  'btn-secondary t-bg-light-gray with-half-radius':
                    consignment.status_human === 'Cancelled'
                }
              ]"
              data-toggle="dropdown"
              :disabled="consignment.status_human === 'Delivered'"
            >
              {{ consignment.status_human }}
            </button>

            <div class="dropdown-menu">
              <a
                v-if="consignment.status_human === 'Booked'"
                class="dropdown-item"
                @click="setNewStatus('In Transit')"
              >
                <i class="fa fa-square" style="color: blue"></i>
                In Transit
              </a>
              <a
                v-if="
                  consignment.status_human === 'Booked' ||
                    consignment.status_human === 'In Transit'
                "
                class="dropdown-item"
                @click="setNewStatus('Delivered')"
                ><i class="fa fa-square" style="color: green"></i>
                Delivered
              </a>
              <a
                v-if="
                  consignment.status_human !== 'Booked' ||
                    consignment.status_human !== 'Delivered'
                "
                class="dropdown-item"
                @click="setNewETA('ETA')"
                style="font-size: 10px; font-style: italic"
                ><i class="fa fa-square" style="color: yellow"></i>
                (Update ETA)
              </a>
            </div>
          </div>
          <button
            v-if="consignment.status_human !== 'Delivered'"
            role="button"
            type="button"
            class="btn"
            style="color: #fff; margin: 0 0 0 1px; border-radius: 0 5px 5px 0"
            :class="[
              {
                'btn-error t-bg-crimson':
                  consignment.status_human === 'Booked' &&
                  (convertPickupAfter(consignment.pickup_after) > currentDate ||
                    Boolean(consignment.ready_for_pickup) === false)
              },
              {
                'btn-warning t-bg-orange':
                  consignment.status_human === 'Booked' &&
                  (convertPickupAfter(consignment.pickup_after) <=
                    currentDate ||
                    Boolean(consignment.ready_for_pickup) === true)
              },
              {
                'btn-info t-bg-dodger-blue':
                  consignment.status_human === 'In Transit'
              },
              {
                'btn-success t-bg-forest-green':
                  consignment.status_human === 'Delivered'
              },
              {
                'btn-secondary t-bg-light-gray':
                  consignment.status_human === 'Cancelled'
              }
            ]"
            @click="
              updateStatus(consignment, nextStatus(consignment.status_human))
            "
            :disabled="consignment.status_human === 'Delivered'"
          >
            <i class="fas fa-angle-right"></i>
          </button>
          <div
            v-if="showDate"
            style="
              position: absolute;
              top: 40px;
              left: 12px;
              background: #fff;
              border: 1px solid #ccc;
              padding: 10px;
              z-index: 10000;
            "
          >
            <h2 style="margin-bottom: 10px" v-if="newStatus !== 'ETA'">
              SELECT DATE AND TIME
              {{
                consignment.status_human === "Booked"
                  ? "PICKED UP"
                  : "DELIVERED"
              }}
            </h2>
            <h2 style="margin-bottom: 10px" v-if="newStatus === 'ETA'">
              CHANGE DELIVERY ETA DATE AND TIME
            </h2>
            <div class="t-flex">
              <v-date-picker v-model="statusDate" mode="dateTime" />
              <div style="flex-direction: column; padding-left: 10px">
                <button
                  class="btn btn-primary"
                  style="width: 100%; margin-bottom: 10px"
                  v-if="newStatus !== 'ETA'"
                  @click="updateStatusWithDate(consignment)"
                >
                  Update
                </button>
                <button
                  class="btn btn-success"
                  style="width: 100%; margin-bottom: 10px"
                  v-if="newStatus === 'ETA'"
                  @click="updateETAWithDate(consignment)"
                  :disabled="isDisabled"
                >
                  Update
                </button>
                <button
                  class="btn btn-danger"
                  style="width: 100%; margin-bottom: 10px"
                  @click="updateClose"
                >
                  Cancel
                </button>
              </div>
            </div>
            <div v-if="newStatus === 'ETA'">
              <h2 style="margin: 10px 0 0 0">REASON</h2>
              <span
                style="font-size: 10px"
                :class="[{ 'text-error': hasError }]"
              >
                Please provide commentary as to why delivery ETA has changed
              </span>
              <input
                type="text"
                name="reason"
                class="form-control"
                v-model="reason"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="md:t-w-1/5">
        <multiselect
          v-model="truckAllocation"
          :options="trucks"
          placeholder="Allocate a truck"
          :custom-label="nameWithLang"
          track-by="id"
          @input="handleTruckAllocation"
        >
        </multiselect>
      </div>
      <a :href="'/carry-freight/legs/manifest/' + consignment.id + '.pdf'">
        <button
          class="t-bg-blue-500 t-font-semibold t-text-white t-py-2 t-px-3 t-border t-border-blue-500 t-rounded"
        >
          <i class="fas fa-download"></i>
          Download Manifest
        </button>
      </a>
      <a
        v-if="consignment.damage_claims.length"
        @click="showDamageClaim = !showDamageClaim"
      >
        <button
          class="t-bg-yellow-500 t-font-semibold t-text-white t-py-2 t-px-3 t-border t-border-yellow-500 t-rounded"
        >
          {{ showDamageClaim ? "Hide" : "Show" }} Damage Claim
        </button>
      </a>
      <p>${{ consignment.price }}</p>
    </div>

    <div
      class="
        t-border-t-2 t-border-b-2 t-border-gray-300 t-flex t-flex-col t-pb-2
        md:t-flex-row md:t-justify-between md:t-pb-0
      "
    >
      <div
        class="
          t-grid t-grid-flow-row t-auto-rows-max t-grid-cols-1 t-py-1
          md:t-grid-rows-1
          md:t-grid-flow-col
          md:t-auto-cols-fr
          md:t-py-3
          md:t-divide-gray-300
        "
      >
        <div class="md:t-col-span-2 md:t-border-r-2">
          <p
            class="
              t-text-gray-800
              t-tracking-wide
              t-uppercase
              t-text-sm
              t-font-semibold
            "
          >
            Pickup Requires Tail Lift ?
          </p>
          <p class="t-text-black">
            {{ consignment.pickup_location.requires_taillift ? "Yes" : "No" }}
          </p>
        </div>
        <div class="md:t-col-span-2 md:t-px-4 md:t-border-r-2">
          <p
            class="
              t-text-gray-800
              t-tracking-wide
              t-uppercase
              t-text-sm
              t-font-semibold
            "
          >
            Delivery Requires Tail Lift ?
          </p>
          <p class="t-text-black">
            {{ consignment.delivery_location.requires_taillift ? "Yes" : "No" }}
          </p>
        </div>
        <div class="md:t-col-span-2 md:t-px-4 md:t-border-r-2">
          <p
            class="
              t-text-gray-800
              t-tracking-wide
              t-uppercase
              t-text-sm
              t-font-semibold
            "
          >
            <b>Pickup Ref:</b> {{ separateRef(consignment.pickup_ref) }}<br />
            <b>Delivery Reference:</b>
            {{ separateRef(consignment.delivery_ref) }}
          </p>
        </div>
        <div class="md:t-col-span-1 md:t-px-4">
          <p
            class="
              t-text-gray-800
              t-tracking-wide
              t-uppercase
              t-text-sm
              t-font-semibold
            "
          >
            <!-- Dangerous Goods Icon -->
            <a-popover v-if="consignment.contains_dgs">
              <template slot="content">
                <span>Contains Dangerous Goods</span>
              </template>
              <icon-font-cn type="iconskeleton" class="t-mt-1" />
            </a-popover>

            <!-- Pickup TailLift Icon -->
            <a-popover
              placement="top"
              v-if="consignment.pickup_location.requires_taillift"
            >
              <template slot="content">
                <span>Pickup location requires a tail lift</span>
              </template>
              <tail-lift-icon class="t-flex t-w-4 t-h-4 t-mt-1" />
            </a-popover>

            <!-- Delivery TailLift Icon -->
            <a-popover
              placement="top"
              v-if="consignment.delivery_location.requires_taillift"
            >
              <template slot="content">
                <span>Delivery location requires a tail lift</span>
              </template>
              <tail-lift-icon class="t-flex t-w-4 t-h-4 t-mt-1" />
            </a-popover>

            <!-- Consignment Red Clock -->
            <a-popover placement="topLeft" v-if="consignment.red_clock !== 0">
              <template slot="content">
                <span>
                  Behind the schedule, please
                  <a href="/contact" target="_blank"> contact Freighthub</a>
                  for more details
                </span>
              </template>

              <div style="color: red">
                <span
                  ><i class="fa fa-clock" aria-hidden="true" /> +{{
                    consignment.red_clock
                  }}</span
                >
              </div>
            </a-popover>

            <!-- Consignment Green Clock -->
            <a-popover placement="topLeft" v-if="consignment.green_clock !== 0">
              <template slot="content">
                <span>
                  Delivered 1 day ahead of schedule
                </span>
              </template>

              <div style="color: green">
                <span
                  ><i class="fa fa-clock" aria-hidden="true" /> -{{
                    consignment.green_clock
                  }}</span
                >
              </div>
            </a-popover>
          </p>
        </div>

        <div class="md:t-col-span-2 md:t-px-4 md:t-border-l-2">
          <p
            class="
              t-text-gray-800
              t-tracking-wide
              t-uppercase
              t-text-sm
              t-font-semibold
            "
          >
            <b>Bin Location:</b>
            <span v-if="consignment.bookings.length > 0">
              <span
                v-for="(booking, index) in consignment.bookings"
                :key="booking.id"
              >
                {{ booking.number }}
                (
                <span v-if="booking.bin_locations.length > 0">
                  <span
                    v-for="(bin_location, idx) in booking.bin_locations"
                    :key="bin_location.id"
                  >
                    {{ bin_location.name }}
                    <span v-if="idx != booking.bin_locations.length - 1"
                      >,</span
                    >
                  </span>
                </span>
                <span v-else>
                  -
                </span>
                )
                <span v-if="index != consignment.bookings.length - 1">,</span>
              </span>
            </span>
            <span v-else>
              -
            </span>
          </p>
        </div>
      </div>
    </div>

    <!-- Card Body -->
    <div
      class="
        t-grid t-grid-rows-3 t-grid-cols-1 t-gap-y-3 t-mt-2
        md:t-grid-rows-1 md:t-grid-cols-12 md:t-gap-x-2
      "
    >
      <!-- Pickup From -->
      <div class="md:t-col-span-3">
        <p
          class="
            t-text-sm
            t-uppercase
            t-tracking-wide
            t-text-dodger-blue
            t-font-semibold
            t-my-1
          "
        >
          From
        </p>
        <p class="t-font-semibold">{{ consignment.pickup_location.name }}</p>
        <p>
          {{ consignment.pickup_location.address.street_number }}
          {{ consignment.pickup_location.address.street_name }}
        </p>
        <p>{{ consignment.pickup_location.address.suburb }}</p>
        <p>{{ consignment.pickup_location.address.region }}</p>

        <p class="t-mt-3">
          Pickup After
          {{ moment(consignment.pickup_after).format("hh:mm A ddd DD MMM") }}
        </p>
        <p v-if="consignment.pickup_before">
          Pickup Before
          {{ moment(consignment.pickup_before).format("hh:mm A ddd DD MMM") }}
        </p>
      </div>

      <!-- Delivery To -->
      <div class="md:t-col-span-3">
        <p
          class="
            t-text-sm
            t-uppercase
            t-tracking-wide
            t-text-dodger-blue
            t-font-semibold
            t-my-1
          "
        >
          To
        </p>
        <p class="t-font-semibold">{{ consignment.delivery_location.name }}</p>
        <p>
          {{ consignment.delivery_location.address.street_number }}
          {{ consignment.delivery_location.address.street_name }}
        </p>
        <p>{{ consignment.delivery_location.address.suburb }}</p>
        <p>{{ consignment.delivery_location.address.city }}</p>

        <p v-if="consignment.deliver_before" class="t-font-medium t-mt-2">
          Deliver By:
          <span class="t-font-normal">
            {{
              moment(consignment.deliver_before).format("hh:mm A ddd DD MMM")
            }}
          </span>
        </p>
      </div>

      <!-- Freight Information -->
      <div class="md:t-col-span-6">
        <p
          class="
            t-text-sm
            t-uppercase
            t-tracking-wide
            t-text-dodger-blue
            t-font-semibold
            t-border-b-2
            t-border-gray-300
            t-pb-1
            t-mb-2
          "
        >
          Freight
        </p>

        <div
          class="t-grid t-grid-cols-5 t-grid-rows-1 t-gap-x-2"
          v-for="(freight, index) in consignment.lines"
          :key="index"
        >
          <p class="t-col-span-3">
            {{ freight.quantity }} x {{ freight.package_type.name }}
            {{ freight.goods_type.name }} [{{ freight.description }}]
          </p>
          <p>{{ parseFloat(freight.weight) }} kg</p>
          <p>{{ parseFloat(freight.volume) }} m<sup>3</sup></p>
        </div>

        <div
          class="
            t-grid
            t-grid-cols-5
            t-grid-rows-1
            t-font-medium
            t-mt-1
            t-border-t
            t-border-gray-300
            t-gap-x-2
          "
        >
          <p class="t-col-span-3">Total</p>
          <p>{{ totalFreightWeight }} kg</p>
          <p>{{ totalFreightVolume }} m<sup>3</sup></p>
        </div>

        <div
          v-if="consignment.contains_dgs"
          class="t-mt-1 t-font-medium t-border-t t-border-gray-300 t-text-sm"
        >
          <p>Contains Dangerous Goods</p>
        </div>
      </div>
    </div>

    <div v-if="showDamageClaim" class="t-pb-2">
      <p
        class="
          t-text-sm
          t-uppercase
          t-text-dodger-blue
          t-font-semibold
          t-border-gray-300
          t-mt-4
          t-pt-2
          t-border-t-2
        "
      >
        Damage Claims
      </p>

      <div
        class="
          t-grid
          t-grid-cols-5
          t-grid-rows-1
          t-font-medium
          t-mt-1
          t-pb-1
          t-border-gray-300
          t-gap-x-2
        "
      >
        <p class="t-col-span-2 t-font-semibold">Claim</p>
        <p class="t-col-span-3 t-font-semibold">Files</p>
      </div>

      <div
        class="t-grid t-grid-cols-5 t-grid-rows-1 t-gap-x-2"
        v-for="(claim, index) in consignment.damage_claims"
        :key="index"
      >
        <p class="t-col-span-2">{{ claim.solution }}</p>
        <p class="t-col-span-3">
          <span v-for="(file, idx) in claim.files" :key="idx">
            <a
              v-if="idx != claim.files.length - 1"
              :href="'/customer-files/' + file.id"
              >{{ file.name }},
            </a>
            <a v-else :href="'/customer-files/' + file.id">{{ file.name }}</a>
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import IconFontCn from "../../../icons/IconFontCn";
import TailLiftIcon from "../../../icons/TailLiftIcon";
import Multiselect from "vue-multiselect";

export default {
  components: {
    TailLiftIcon,
    IconFontCn,
    Multiselect
  },
  name: "ConsignmentCard",
  description: "",
  props: {
    consignment: {
      type: Object
    },
    trucks: {
      type: Array
    }
  },
  data() {
    return {
      currentDate: moment().format("YYYY-MM-DD HH:mm"),
      statusDate: moment().format("YYYY-MM-DD HH:mm"),
      newStatus: null,
      showDate: false,
      reason: null,
      hasError: false,
      isDisabled: false,
      showDamageClaim: false,
      truckAllocation:
        this.consignment.truck_allocation_id == null
          ? {
              id: null,
              plate: null,
              display_name: "Unallocated"
            }
          : JSON.parse(this.consignment.truck_allocation_id)
    };
  },
  computed: {
    totalFreightWeight: function() {
      return this.consignment.lines
        .reduce((totalWeight, freightLine) => {
          return totalWeight + parseFloat(freightLine.weight);
        }, 0.0)
        .toFixed(2);
    },
    totalFreightVolume: function() {
      return this.consignment.lines
        .reduce((totalVolume, freightLine) => {
          return totalVolume + parseFloat(freightLine.volume);
        }, 0.0)
        .toFixed(2);
    }
  },
  methods: {
    convertPickupAfter(pickupAfter) {
      return moment(pickupAfter).format("YYYY-MM-DD HH:mm");
    },

    setNewStatus(status) {
      this.newStatus = status;
      this.showDate = true;
    },

    setNewETA(status) {
      this.newStatus = status;
      this.showDate = true;
    },

    updateETAWithDate(consignment) {
      this.isDisabled = true;

      if (!this.reason) {
        this.hasError = true;
        this.isDisabled = false;
      } else {
        this.hasError = false;
      }

      if (!this.hasError) {
        let dateTime = moment(this.statusDate);
        let validDate = moment.isMoment(dateTime);
        let etaTime = validDate
          ? dateTime.format("ddd D MMM gggg h A")
          : moment.format("ddd D MMM gggg h A");

        axios
          .post("/carry-freight/legs/" + consignment.id + "/eta", {
            eta_time: etaTime,
            reason: this.reason
          })
          .then(response => {
            let data = response.data;

            if (data.is_success) {
              this.$swal({
                title: data.message,
                type: "success"
              });
              this.isDisabled = false;
              this.$parent.fetchConsignments(this.$parent.page);
            } else {
              this.$swal({
                title: data.message,
                type: "error"
              });
            }
          })
          .catch(e => {
            Event.$emit("serverError");
            console.log(e);
          });
      }
    },

    updateStatus(consignment, statusHuman) {
      let endPoint;

      let payload = {
        update_time: moment().format("ddd D MMM gggg h A")
      };

      switch (statusHuman) {
        case "In Transit":
          endPoint = "/carry-freight/bookings/" + consignment.id + "/pickup";
          this.updateDateTime(consignment, endPoint, payload);
          break;
        case "Delivered":
          endPoint = "/carry-freight/bookings/" + consignment.id + "/delivered";
          this.updateDateTime(consignment, endPoint, payload);
          break;
        case "Cancel":
          endPoint = "/carry-freight/bookings/" + consignment.id + "/cancel";
          this.updateDateTime(consignment, endPoint, payload);
          break;
        default:
          break;
      }
    },

    updateStatusWithDate(consignment) {
      let endPoint;

      let dateTime = moment(this.statusDate);
      let validDate = moment.isMoment(dateTime);
      dateTime = validDate
        ? dateTime.format("ddd D MMM gggg h A")
        : moment().format("ddd D MMM gggg h A");

      let payload = {
        update_time: dateTime
      };

      switch (this.newStatus) {
        case "In Transit":
          endPoint = "/carry-freight/bookings/" + consignment.id + "/pickup";
          this.updateDateTime(consignment, endPoint, payload);
          break;
        case "Delivered":
          endPoint = "/carry-freight/bookings/" + consignment.id + "/delivered";
          this.updateDateTime(consignment, endPoint, payload);
          break;
        case "Cancel":
          endPoint = "/carry-freight/bookings/" + consignment.id + "/cancel";
          this.updateDateTime(consignment, endPoint, payload);
          break;
        default:
          break;
      }
    },

    updateDateTime(consignment, endpoint, payload) {
      axios
        .put(endpoint, payload)
        .then(response => {
          let data = response.data;

          if (data.is_success) {
            this.$swal({
              title: data.message,
              type: "success"
            });
            this.isDisabled = false;
            this.$parent.fetchConsignments(this.$parent.page);
          } else {
            this.$swal({
              title: data.message,
              type: "error"
            });
          }
        })
        .catch(e => {
          Event.$emit("serverError");
          console.log(e);
        });
    },

    nextStatus(statusHuman) {
      if (statusHuman === "Booked") {
        return "In Transit";
      } else if (statusHuman === "In Transit") {
        return "Delivered";
      }
    },

    updateClose() {
      this.newStatus = null;
      this.showDate = false;
    },

    moment(...args) {
      return moment(...args);
    },

    separateRef(ref) {
      if (Array.isArray(ref)) {
        return ref.join();
      } else {
        return ref;
      }
    },
    nameWithLang({ plate, display_name }) {
      return plate ? `${display_name} - (${plate})` : `${display_name}`;
    },
    handleTruckAllocation(value, id) {
      this.truckAllocation = this.truckAllocation.id === null ? null : value;

      axios
        .put(
          "/carry-freight/bookings/" + this.consignment.id + "/allocate-truck",
          {
            truckAllocation: this.truckAllocation
          }
        )
        .then(response => {
          let data = response.data;

          if (data.is_success) {
            this.$swal({
              title: data.message,
              type: "success"
            });
            this.isDisabled = false;
            this.$parent.fetchConsignments(this.$parent.page);
          } else {
            this.$swal({
              title: data.message,
              type: "error"
            });
          }
        })
        .catch(e => {
          Event.$emit("serverError");
          console.log(e);
        });
    }
  }
};
</script>

<style scoped></style>
